import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import styled from "styled-components";

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export function Main() {
  return (
    <StyledContainer>
      <Button variant="contained" href="/waiver">
        Waiver
      </Button>
    </StyledContainer>
  );
}
